import { render, staticRenderFns } from "./chemGhs3.vue?vue&type=template&id=0a7fd5e1"
import script from "./chemGhs3.vue?vue&type=script&lang=js"
export * from "./chemGhs3.vue?vue&type=script&lang=js"
import style0 from "./chemGhs3.vue?vue&type=style&index=0&id=0a7fd5e1&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a7fd5e1')) {
      api.createRecord('0a7fd5e1', component.options)
    } else {
      api.reload('0a7fd5e1', component.options)
    }
    module.hot.accept("./chemGhs3.vue?vue&type=template&id=0a7fd5e1", function () {
      api.rerender('0a7fd5e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chemGhs3.vue"
export default component.exports